module.exports = __webpack_public_path__ + "img/Hat04_U2_6.6f4c476d.svg";